import { useMemo } from 'react';

import { useAllTagsQuery } from '../../Project/queries';
import { AllTagsResponse, AllTagsOptions } from '../../Project/queries/apiTypes';

export const useAllTagsHook = () => {
    const { data: allTagsApiData, isLoading } = useAllTagsQuery();

    const allTagsData = useMemo(() => {
        if (!allTagsApiData?.data) return [];
        return allTagsApiData.data.map((option: AllTagsResponse): AllTagsOptions => {
            return {
                label: option.tag_name,
                value: option.tag_id,
                entity_type: option.entity_type,
                order: option.order
            };
        });
    }, [allTagsApiData?.data]);

    const allTagsObject = useMemo(() => {
        const dataObj: Map<number | null, string | null> = new Map();
        if (allTagsData.length) {
            allTagsData.forEach((tag) => {
                dataObj.set(tag.value, tag.label);
            });
        }
        return dataObj;
    }, [allTagsData]);

    return { allTagsObject, allTagsData, isLoading };
};
